module.exports = __webpack_public_path__ + "static/media/lock-and-key.d37bdcc6.svg";